import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar'
import SearchSection from '../../components/SearchSection';
import Destination from '../../components/Destination'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
import SEO from '../../components/SEO';

const HomePage =() => {
    return(
        <Fragment>
            <SEO pageName="home" />
            <Navbar/>
            <SearchSection/>
            <Destination/>
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};
export default HomePage;